export default "__VITE_ASSET__C0bQBNBU__"